/* ==========================================================================
   AirSeat35 広告LP スクリプト
   assets/airseat35-lp.js

   ・Shopify商品バリエーション連携
   ・在庫判定
   ・予約販売
   ・発送予定日自動計算
   ・カート追加
   ・checkout遷移
   ・固定CTA
   ・FAQ
   ========================================================================== */


function as35TrackEvent(name, params){

  params = params || {};

  if(typeof window.gtag === 'function'){

    window.gtag(
      'event',
      name,
      params
    );

  }else{

    console.log(
      '[as35-track]',
      name,
      params
    );

  }

}


as35TrackEvent(
  'lp_view'
);


function as35ScrollToId(id){

  const el =
    document.getElementById(
      id
    );

  if(el){

    el.scrollIntoView({
      behavior:'smooth'
    });

  }

}


function as35ToggleAccordion(head){

  const item =
    head.closest(
      '.as35-accordion-item'
    );

  if(item){

    item.classList.toggle(
      'open'
    );

  }

}



/* ==========================================================================
   50%スクロール計測
   ========================================================================== */

(function(){

  let tracked = false;

  window.addEventListener(
    'scroll',
    ()=>{

      const ratio =
        (
          window.scrollY +
          window.innerHeight
        ) /
        document.body.scrollHeight;


      if(
        !tracked &&
        ratio > 0.5
      ){

        tracked = true;

        as35TrackEvent(
          'scroll_50'
        );

      }

    },
    {
      passive:true
    }
  );

})();



/* ==========================================================================
   固定CTA
   ========================================================================== */

(function(){

  const fv =
    document.getElementById(
      'as35-fv'
    );

  const purchase =
    document.getElementById(
      'as35-purchase'
    );

  const sticky =
    document.getElementById(
      'as35StickyCta'
    );


  if(
    !fv ||
    !sticky
  ){
    return;
  }


  let pastFv =
    false;

  let purchaseInView =
    false;


  function update(){

    sticky.classList.toggle(
      'show',
      pastFv &&
      !purchaseInView
    );

  }


  new IntersectionObserver(
    entries=>{

      entries.forEach(
        e=>{

          pastFv =
            !e.isIntersecting;

          update();

        }
      );

    },
    {
      threshold:0
    }

  ).observe(
    fv
  );


  if(purchase){

    new IntersectionObserver(
      entries=>{

        entries.forEach(
          e=>{

            purchaseInView =
              e.isIntersecting;

            update();

          }
        );

      },
      {
        threshold:0.15
      }

    ).observe(
      purchase
    );

  }

})();



/* ==========================================================================
   商品購入 / 予約販売
   ========================================================================== */

(function(){

  const root =
    document.getElementById(
      'as35-purchase-form'
    );


  if(!root){
    return;
  }


  let productData;


  try{

    productData =
      JSON.parse(
        document
          .getElementById(
            'as35-product-json'
          )
          .textContent
      );

  }catch(e){

    console.error(
      'AirSeat35 商品データの読み込みに失敗しました',
      e
    );

    return;

  }



  const priceEl =
    root.querySelector(
      '.as35-purchase-price'
    );


  const stockEl =
    root.querySelector(
      '.as35-purchase-stock'
    );


  const buyBtn =
    root.querySelector(
      '.as35-buy-btn'
    );


  const errorEl =
    root.querySelector(
      '.as35-purchase-error'
    );


  const qtyValueEl =
    root.querySelector(
      '.as35-qty-value'
    );


  const optionGroups =
    root.querySelectorAll(
      '.as35-option-group[data-option-index]'
    );


  const reservationNotice =
    document.getElementById(
      'as35ReservationNotice'
    );


  const reservationDateEl =
    document.getElementById(
      'as35ReservationDate'
    );



  /* ==========================================================================
     初期バリエーション

     Liquid側の selected_or_first_available_variant を使い、
     Shopifyが初期選択したvariantとJS側の選択状態を一致させる。
     ========================================================================== */

  let selectedOptions = [];


  try{

    const selectedVariantElement =
      document.getElementById(
        'as35-selected-variant-id'
      );


    const initialVariantId =
      JSON.parse(
        selectedVariantElement.textContent
      );


    const initialVariant =
      productData.find(
        variant =>
          String(variant.id) ===
          String(initialVariantId)
      );


    selectedOptions =
      initialVariant
        ? initialVariant.options.slice()
        : productData[0]
          ? productData[0].options.slice()
          : [];


  }catch(e){

    selectedOptions =
      productData[0]
        ? productData[0].options.slice()
        : [];

  }



  let quantity =
    1;



  /* ==========================================================================
     価格表示
     ========================================================================== */

  function formatPrice(cents){

    return (
      '¥' +
      Math
        .round(
          cents / 100
        )
        .toLocaleString(
          'ja-JP'
        )
    );

  }



  /* ==========================================================================
     選択中variantを取得
     ========================================================================== */

  function findVariant(options){

    return productData.find(
      v =>
        v.options.every(
          (val, idx) =>
            val === options[idx]
        )
    );

  }



  /* ==========================================================================
     カレンダー上1か月後の日付を取得

     例：
     9/17 → 10/17
     10/31 → 11/30
     1/31 → 2/28 または 2/29
     ========================================================================== */

  function addOneCalendarMonthClamped(date){

    const y =
      date.getFullYear();

    const m =
      date.getMonth();

    const d =
      date.getDate();


    const target =
      new Date(
        y,
        m + 1,
        1
      );


    const ty =
      target.getFullYear();

    const tm =
      target.getMonth();


    const last =
      new Date(
        ty,
        tm + 1,
        0
      ).getDate();


    return new Date(
      ty,
      tm,
      Math.min(
        d,
        last
      )
    );

  }



  function formatJapaneseDate(date){

    return (
      `${date.getFullYear()}年` +
      `${date.getMonth() + 1}月` +
      `${date.getDate()}日頃`
    );

  }



  const reservationDateText =
    formatJapaneseDate(
      addOneCalendarMonthClamped(
        new Date()
      )
    );


  if(reservationDateEl){

    reservationDateEl.textContent =
      reservationDateText;

  }



  /* ==========================================================================
     予約対象判定

     ・Shopify在庫管理ON
     ・在庫0以下
     ・在庫切れでも販売を続ける（continue）

     この3条件を満たす場合のみ予約販売
     ========================================================================== */

  function isReservationVariant(variant){

    if(!variant){
      return false;
    }


    return (

      variant.inventory_management != null &&

      Number(
        variant.inventory_quantity
      ) <= 0 &&

      variant.inventory_policy ===
        'continue'

    );

  }



  /* ==========================================================================
     購入可能判定
     ========================================================================== */

  function isPurchasableVariant(variant){

    return (

      !!variant &&

      (
        variant.available ||
        isReservationVariant(
          variant
        )
      )

    );

  }



  /* ==========================================================================
     UI更新
     ========================================================================== */

  function updateUI(){

    const variant =
      findVariant(
        selectedOptions
      );


    optionGroups.forEach(
      group=>{

        const optionIndex =
          parseInt(
            group.dataset.optionIndex,
            10
          );


        group
          .querySelectorAll(
            '.as35-option-chip'
          )
          .forEach(
            chip=>{

              const value =
                chip.dataset.value;


              chip.classList.toggle(
                'is-selected',
                selectedOptions[
                  optionIndex
                ] === value
              );


              const testOptions =
                selectedOptions.slice();


              testOptions[
                optionIndex
              ] =
                value;


              const matching =
                productData.filter(
                  v =>
                    v.options.every(
                      (val, idx) =>
                        idx ===
                          optionIndex ||
                        val ===
                          testOptions[idx]
                    )
                );


              chip.disabled =
                !matching.some(
                  v =>
                    isPurchasableVariant(
                      v
                    )
                );

            }
          );

      }
    );


    if(reservationNotice){

      reservationNotice.hidden =
        true;

    }


    if(!variant){

      stockEl.textContent =
        'この組み合わせは選択できません';


      stockEl.className =
        'as35-purchase-stock out';


      buyBtn.textContent =
        'AirSeat35を購入する';


      buyBtn.disabled =
        true;


      return;

    }



    priceEl.textContent =
      formatPrice(
        variant.price
      );



    /*
      予約判定は variant.available より先に行う。

      Shopifyでは
      「在庫切れでも販売を続ける」
      がONの場合、
      在庫0でもavailable=trueになるため。
    */

    if(
      isReservationVariant(
        variant
      )
    ){

      stockEl.textContent =
        '予約販売受付中';


      stockEl.className =
        'as35-purchase-stock in';


      buyBtn.textContent =
        '予約注文する';


      buyBtn.disabled =
        false;


      if(reservationNotice){

        reservationNotice.hidden =
          false;

      }


    }else if(
      variant.available
    ){

      stockEl.textContent =
        '在庫あり';


      stockEl.className =
        'as35-purchase-stock in';


      buyBtn.textContent =
        'AirSeat35を購入する';


      buyBtn.disabled =
        false;


    }else{

      stockEl.textContent =
        '売り切れ';


      stockEl.className =
        'as35-purchase-stock out';


      buyBtn.textContent =
        '売り切れ';


      buyBtn.disabled =
        true;

    }


    qtyValueEl.textContent =
      quantity;

  }



  /* ==========================================================================
     バリエーション選択
     ========================================================================== */

  optionGroups.forEach(
    group=>{

      const optionIndex =
        parseInt(
          group.dataset.optionIndex,
          10
        );


      group
        .querySelectorAll(
          '.as35-option-chip'
        )
        .forEach(
          chip=>{

            chip.addEventListener(
              'click',
              ()=>{

                if(chip.disabled){
                  return;
                }


                selectedOptions[
                  optionIndex
                ] =
                  chip.dataset.value;


                updateUI();

              }
            );

          }
        );

    }
  );



  /* ==========================================================================
     数量変更
     ========================================================================== */

  const qtyMinus =
    root.querySelector(
      '.as35-qty-minus'
    );


  const qtyPlus =
    root.querySelector(
      '.as35-qty-plus'
    );


  if(qtyMinus){

    qtyMinus.addEventListener(
      'click',
      ()=>{

        if(quantity > 1){

          quantity--;

          updateUI();

        }

      }
    );

  }


  if(qtyPlus){

    qtyPlus.addEventListener(
      'click',
      ()=>{

        quantity++;

        updateUI();

      }
    );

  }



  /* ==========================================================================
     購入 / 予約注文
     ========================================================================== */

  buyBtn.addEventListener(
    'click',
    ()=>{


      const variant =
        findVariant(
          selectedOptions
        );


      if(
        !isPurchasableVariant(
          variant
        )
      ){

        errorEl.textContent =
          'この組み合わせは現在ご購入いただけません。';


        errorEl.classList.add(
          'show'
        );


        return;

      }



      const reservation =
        isReservationVariant(
          variant
        );


      errorEl.classList.remove(
        'show'
      );


      buyBtn.disabled =
        true;


      const originalText =
        buyBtn.textContent;


      buyBtn.textContent =
        '処理中…';



      const cartItem = {

        id:
          variant.id,

        quantity:
          quantity

      };



      /*
        予約商品の場合のみ
        line item propertyを追加
      */

      if(reservation){

        cartItem.properties = {

          '予約商品':
            `${reservationDateText}発送予定`

        };

      }



      as35TrackEvent(
        'cta_click',
        {

          loc:
            'as35_purchase',

          order_type:
            reservation
              ? 'reservation'
              : 'normal'

        }
      );



      fetch(
        '/cart/add.js',
        {

          method:
            'POST',


          headers:{

            'Content-Type':
              'application/json',

            'Accept':
              'application/json'

          },


          body:
            JSON.stringify(
              cartItem
            )

        }
      )


      .then(
        res=>{

          if(!res.ok){

            throw new Error(
              'cart add failed'
            );

          }


          return res.json();

        }
      )


      .then(
        ()=>{

          window.location.href =
            '/checkout';

        }
      )


      .catch(
        err=>{

          console.error(
            'AirSeat35 カート追加エラー',
            err
          );


          errorEl.textContent =
            'カートへの追加に失敗しました。時間をおいて再度お試しください。';


          errorEl.classList.add(
            'show'
          );


          buyBtn.disabled =
            false;


          buyBtn.textContent =
            originalText;

        }
      );

    }
  );



  /* ==========================================================================
     初回UI反映
     ========================================================================== */

  updateUI();

})();